import { render } from "./CircularGraph.vue?vue&type=template&id=b7e2b7e8&scoped=true"
import script from "./CircularGraph.vue?vue&type=script&lang=js"
export * from "./CircularGraph.vue?vue&type=script&lang=js"

import "./CircularGraph.vue?vue&type=style&index=0&id=b7e2b7e8&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7e2b7e8"]])

export default __exports__